import epytJson from './lotties/epyt.json';

export const Images = {
    googleLogo: new URL('./images/login_google.svg', import.meta.url).href,
    kakaoLogo: new URL('./images/login_kakao.svg', import.meta.url).href,
    loader: new URL('./images/loader.png', import.meta.url).href,
    pine: new URL('./images/pine.png', import.meta.url).href,
    cactus: new URL('./images/cactus.png', import.meta.url).href,
    lunchbox: new URL('./images/lunchbox.png', import.meta.url).href,
    chameleon: new URL('./images/chameleon.png', import.meta.url).href,
    octopus: new URL('./images/octopus.png', import.meta.url).href,
    mapCenter: new URL('./images/map_center.png', import.meta.url).href,
    thumb: new URL('./images/thumb.png', import.meta.url).href,
} as const;

export const Logo = {
    purpleSymbol: new URL('./logo/box-purple-symbol.png', import.meta.url).href,
    symbol: new URL('./logo/symbol.png', import.meta.url).href,
} as const;

export const Lotties = {
    epyt: epytJson,
} as const;

export const MainImages = {
    awareness: new URL('./images/main/awareness.webp', import.meta.url).href,
    discovery: new URL('./images/main/discovery.webp', import.meta.url).href,
    download: new URL('./images/main/download.webp', import.meta.url).href,
    expression: new URL('./images/main/expression.webp', import.meta.url).href,
    l: new URL('./images/main/l.webp', import.meta.url).href,
    pouch_content: new URL('./images/main/pouch_content.webp', import.meta.url).href,
    problem: new URL('./images/main/problem.webp', import.meta.url).href,

    brand_l: new URL('./images/main/body/brand_l.webp', import.meta.url).href,
    brand_r: new URL('./images/main/body/brand_r.webp', import.meta.url).href,
    brand: new URL('./images/main/body/brand.webp', import.meta.url).href,
    creator_l: new URL('./images/main/body/creator_l.webp', import.meta.url).href,
    creator_r: new URL('./images/main/body/creator_r.webp', import.meta.url).href,
    creator: new URL('./images/main/body/creator.webp', import.meta.url).href,
    customer_l: new URL('./images/main/body/customer_l.webp', import.meta.url).href,
    customer_r: new URL('./images/main/body/customer_r.webp', import.meta.url).href,
    customer: new URL('./images/main/body/customer.webp', import.meta.url).href,
    matching: new URL('./images/main/body/matching.webp', import.meta.url).href,
    pouch: new URL('./images/goods/pouch.png', import.meta.url).href,
    tint: new URL('./images/goods/tint.png', import.meta.url).href,
};

export const Icons = {
    apple: new URL('./icons/apple.png', import.meta.url).href,
    google_play: new URL('./icons/google_play.png', import.meta.url).href,
    instagram: new URL('./icons/instagram.png', import.meta.url).href,
    tictok: new URL('./icons/tictok.png', import.meta.url).href,
    search: new URL('./icons/search.svg', import.meta.url).href,
    logo: new URL('./icons/logo.svg', import.meta.url).href,
    kit_slaon: new URL('./icons/kit_salon.svg', import.meta.url).href,
};
